import { render, staticRenderFns } from "./beltTransfer.vue?vue&type=template&id=0f7d1a68&scoped=true&"
import script from "./beltTransfer.vue?vue&type=script&lang=js&"
export * from "./beltTransfer.vue?vue&type=script&lang=js&"
import style0 from "./beltTransfer.vue?vue&type=style&index=0&lang=scss&"
import style1 from "./beltTransfer.vue?vue&type=style&index=1&id=0f7d1a68&lang=scss&scoped=true&"


/* normalize component */
import normalizer from "!../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  "0f7d1a68",
  null
  
)

component.options.__file = "beltTransfer.vue"
export default component.exports